import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';
import { SocketsService } from '../../socket/sockets.service';
import * as moment from 'moment';
import { AppointmentComponent } from 'src/app/appointment-section/appointment/appointment.component';
import { Router, ActivatedRoute } from '@angular/router';
import { DoctorsService } from '../../doctor-service/doctors.service';
import {HttpClientModule} from '@angular/common/http';
import { Message } from 'primeng/api';
import {ToastModule} from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {ConfirmationService,   MessageService} from 'primeng/api';
import { Subscription } from 'rxjs';
// import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  profilesubscription:Subscription;
  uploadedFiles: any[] = [];
  appData = [];
  userToken: string;
  id: string;
  docData;
  token:any;
  clinicId:any;
  isNoti = false;
  count = 0;
  servicesArray = [];
  profileImage;
  curClinic;
  active;
  texts: string[] = [];
  doctype:any;
  constructor(
    private confirmationdailog:ConfirmDialogModule,
    private confirmationService: ConfirmationService, 
    
    private messageService: MessageService,
    private socketService: SocketsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private doctorService: DoctorsService
  ) {
    this.profilesubscription = this.socketService.recieveprofileupdate().subscribe(()=>{
this.getSingleDoctor();
    })
  }

  ngOnInit() {
   this.clinicId = localStorage.getItem('activeClinic');
    this.authService.authDataSubject.pipe(take(1)).subscribe(authData => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.doctype = authData._type;
    });
    this.onSubmit();
    this.getSingleDoctor();
    // this.socketService.profileupdate().subscribe((data)=>{
    //   console.log("socket header",data);
    //   this.getSingleDoctor();
    // })
    this.socketService.onNewAppointmentMessage().subscribe(res => {
      if(res && res.appointment){let data = res.appointment;
      data.patientId = res.patientData;
      this.appData.push({
        name: data.patientName ? data.patientName : null,
        date: moment(data.appointmentDate).format('LL'),
        number: data.appointmentNumber
      });
      this.count = this.count + 1;}
    });
  }
  onUpload(event) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
}
  onClickNoti() {
    this.count = 0;
    this.router.navigate(['appointments'], {
      relativeTo: this.activatedRoute
    });
  }
  // createAccessKeyAuthCode () {
  //   let userId = "b5ce1243-c191-4aa9-b323-b8356b3775f0";
  //   let access_key = "ZDRhNTk0OGQtMDZiMy00MGRhLTg0OWUtZGQ1MThlODhlMzdh";
  //   let url = "https://api.sophtron.com/api/Institution/GetInstitutionByName";
  //   var authPath = url. substring(url.lastIndexOf ("/")) . toLowerCase ();
  //   var httpMethod="POST";
  //   var decodedSecret = atob(access_key);
  //   var plainKey = httpMethod. toUpperCase() + "\n" + authPath;
  //   var hash = CryptoJS.HmacSHA256(plainKey, decodedSecret);
  //   var b64Sig = CryptoJS.enc.Base64.stringify(hash);
  //   var authString = 'FIApiAUTH:' + userId + ":" + b64Sig + ': ' + authPath;
  //   console.log("token",authString);
  //      return authString;
  //   }
  getSingleDoctor() {
    this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
      res => {
        this.docData = res;

        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
     if(this.docData.profileImageThumbnail !==undefined){
        this.profileImage =
          'https://api.doqmatokens.com/' + this.docData.profileImageThumbnail;
        // console.log('doctor data', this.docData);
      }else{
      // alert('hello')
        this.profileImage="../../assets/noimage.png"
      }
        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      error => {
        console.log('error in last esle');
      }
    );
  }
  onClickLogout() {
    this.authService.onLogout();
  }
  onSubmit() {
    console.log('Add Doctor Service');
    this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
      res => {
        this.docData = res;

        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage =
          'https://api.doqmatokens.com/' + this.docData.profileImageThumbnail;
        console.log('doctor data', this.docData);
        this.curClinic = this.docData.clinicId.filter(data => data._id == JSON.parse(this.clinicId));
        console.log("this is the clinic",this.curClinic);
        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      error => {
        console.log('error in last esle');
      }
    )

  }
}
